import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgVmware = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-vmware';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M1.24 6.71c.001.159.129.854.22 1.19.096.354 1.118 3.603 2.363 7.51l.635 1.99h2.048l.973-2.45c2.503-6.307 2.451-6.182 2.687-6.451.242-.276.624-.394 1.072-.333.291.04.51.144.7.335.305.305.28-.091.302 4.639l.02 4.24h1.48l.02-4.14.02-4.14.098-.193c.274-.535.944-.836 1.648-.74.443.06.9.379 1.108.771l.106.202.011 4.13.011 4.13h1.476l.011-4.13.011-4.13.1-.197a1.45 1.45 0 0 1 1.135-.777q.846-.101 1.37.423c.388.387.352-.052.375 4.651l.02 4.14h1.48v-8.4l-.093-.277a4 4 0 0 0-.186-.46c-.35-.693-1.114-1.3-1.901-1.512-.402-.109-1.28-.097-1.698.022-.411.118-.78.313-1.116.592l-.268.223-.178-.164c-.51-.47-1.098-.707-1.86-.75-.855-.048-1.64.202-2.211.704l-.146.128-.252-.205a2.9 2.9 0 0 0-2.411-.58 2.1 2.1 0 0 0-.818.327c-.419.265-.776.679-1.043 1.212-.12.24-.667 1.597-2.362 5.869-.36.907-.667 1.636-.681 1.62-.029-.032-.334-.984-1.672-5.216-.917-2.901-1.024-3.265-1.068-3.644l-.027-.229h-.755c-.691 0-.754.006-.754.07"
    })
  }));
});
export default SvgVmware;